<template>
  <v-container fluid>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card class="maincard" :loading="loading">
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="6">
              <v-card-title>Gerichte</v-card-title>
            </v-col>
            <v-col cols="12" xs="12" sm="6" style="text-align: right;">
              <v-btn color="secondary" @click="showImportDialog" class="ml-3"
                >Importieren</v-btn
              >
              <v-btn to="/meal/edit" color="success" class="ml-3">
                <v-icon style="margin-right: 10px;">mdi-food-turkey</v-icon>
                <span>Neues Gericht</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-card>
            <v-container fluid>
              <v-card outlined>
                <v-row class="pa-4">
                  <v-col sm="8">
                    <v-text-field
                      label="Gericht suchen"
                      dense
                      v-model="mealSearch"
                      name="suche"
                      outlined
                      clearable
                    />
                  </v-col>
                  <v-col sm="3">
                    <v-select
                      label="Kategorienfilter"
                      dense
                      multiple
                      chips
                      :items="kategorienList"
                      v-model="filterKategorien"
                    />
                  </v-col>
                  <v-col sm="1">
                    <v-btn-toggle v-model="contentView">
                      <v-btn medium><v-icon>mdi-view-list</v-icon></v-btn>
                      <v-btn medium><v-icon>mdi-view-grid</v-icon></v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
            <MealList
              v-if="contentView == 0"
              :items="mealList"
              @deleteItem="askDeleteGericht"
              @editItem="editItem"
              @infoItem="infoItem"
              @deleteSelectedItems="askDeleteSelectedItems"
            />
            <MealCardList
              v-else-if="contentView == 1"
              :items="mealList"
              @deleteItem="askDeleteGericht"
              @editItem="editItem"
              @infoItem="infoItem"
            />
          </v-card>
        </v-container>
      </v-card>
    </v-col>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Gericht löschen?</v-card-title>
        <v-card-text>
          Soll der Gericht
          <strong>{{ deleteGerichtName }}</strong> wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteMeal">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgDeleteSelected" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Gerichte löschen?</v-card-title>
        <v-card-text>
          Sollen die ausgewählten Gerichte wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            text
            @click="dlgDeleteSelected = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteSelectedMeals">
            <v-icon>mdi-delete</v-icon>Ausgewählte Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgImport" persistent max-width="90%">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Speisen importieren</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dlgImport = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-text>
          <mealImport
            @close="dlgImport = false"
            @cancel="dlgImport = false"
            @importCompleted="importComplete"
            :axiosInstance="getAxiosInstance()"
            importUrl="/meal/import"
            :importFields="importFields"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import MealList from "@/components/meals/MealList";
import MealCardList from "@/components/meals/MealCardList";
import mealImport from "@/components/csv-import/mealImport";
import DataService from "@/services/DataService";

export default {
  name: "MealMgmt",
  data: () => ({
    loading: false,
    dlgDelete: false,
    dlgDeleteSelected: false,
    deleteItem: false,
    deleteSelectedItems: null,
    deleteGerichtName: "",
    dlgImport: false,

    importFields: [
      { text: "Gerichtnr", value: "gerichtnr", width: "150px" },
      { text: "Bezeichnung", value: "name", width: "300px" },
      { text: "Kategorie", value: "kategorie" },
      { text: "Preis", value: "preis" },
      { text: "Energie", value: "energie" },
      { text: "Beschreibung", value: "beschreibung" },
      { text: "Vegetarisch", value: "vegetarisch" },
      { text: "Vegan", value: "vegan" },
      { text: "Großgebinde", value: "grossgebinde" },
      { text: "Glutenfrei", value: "glutenfrei" },
      { text: "Laktosefrei", value: "laktosefrei" },
      { text: "Muslime", value: "schweinefleischfrei" },
      { text: "Allergene", value: "allergene" },
      { text: "Zutatenliste", value: "zutatenliste" }
    ]
  }),
  components: { MealList, MealCardList, mealImport },
  methods: {
    getAxiosInstance() {
      return DataService.apiClient;
    },
    showImportDialog() {
      this.dlgImport = true;
    },
    importComplete() {
      this.loadMeals();
    },
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    },
    askDeleteGericht(item) {
      this.deleteGerichtName = item.name;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    askDeleteSelectedItems(items) {
      this.dlgDeleteSelected = true;
      this.deleteSelectedItems = items;
    },
    editItem(item) {
      this.$router.push({ name: "meal-edit", params: { id: item._id } });
    },
    infoItem(item) {
      alert(item.name1);
    },
    deleteMeal() {
      this.dlgDelete = false;
      this.$store.dispatch("meal/deleteMeal", this.deleteItem._id).then(() => {
        this.$notify({
          group: "dataline",
          type: "info",
          title: "Gericht gelöscht",
          text: "Gericht " + this.deleteItem.name + " wurde gelöscht"
        });
        this.deleteGerichtName = "";
      });
    },
    deleteSelectedMeals() {
      this.dlgDeleteSelected = false;
      this.$store
        .dispatch("meal/deleteSelectedMeals", this.deleteSelectedItems)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Gerichte gelöscht",
            text: "Gerichte gelöscht"
          });
        });
    },
    loadMeals() {
      this.loading = true;
      this.$store
        .dispatch("meal/fetchMealList")
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    }
  },
  computed: {
    mealList() {
      if (this.filterKategorien && this.filterKategorien.length > 0) {
        return this.$store.getters["meal/getMealList"].filter(item => {
          return this.filterKategorien.find(
            filter => filter === item.kategorie || filter === item.subkategorie
          );
        });
      } else {
        return this.$store.getters["meal/getMealList"];
      }
    },
    kategorienList() {
      const categories = this.$store.getters["meal/getMealCategories"];
      let foundItems = [];
      categories.forEach(item => {
        foundItems.push({ text: item.name });

        item.subcategories.forEach(cat => {
          foundItems.push({ text: cat, group: item.name });
        });
      });
      return foundItems;
    },
    filterKategorien: {
      get() {
        return this.$store.getters["meal/getFilterKategorien"];
      },
      set(value) {
        this.$store.commit("meal/SET_FILTER_KATEGORIEN", value);
      }
    },

    contentView: {
      get() {
        return this.$store.getters["meal/getContentView"];
      },
      set(value) {
        this.$store.commit("meal/SET_CONTENT_VIEW", value);
      }
    },

    mealSearch: {
      get() {
        return this.$store.getters["meal/getMealSearch"];
      },
      set(value) {
        this.$store.commit("meal/SET_MEAL_SEARCH", value);
      }
    }
  },
  created() {
    this.loadMeals();
    const getCategories = async () => {
      await this.$store.dispatch("meal/fetchMealCategories");
    };

    getCategories();
  }
};
</script>
<style scoped></style>
